export const FILTER_CATEGORY_KEY = 'filterCategory';
export const FILTER_OPTION_KEY = 'filterOption';

export type FilterOption = {
  $unique_key: number;
  optionName: string;
  optionValue: string;
};

export type FilterCategory = {
  $unique_key: number;
  categoryName: string;
  categoryValue: string;
  filterOptions: FilterOption[];
};

export type MultilevelFiltersProps = {
  filterCategories: FilterCategory[];
};
